<template>
  <div class="gmf-context">
    <div class="gmf-loot-crate-list-container">
      <div class="gmf-loot-crate-list-header gmf-loot-crate-list-padding">
        <div class="gmf-loot-crate-list-header-top">
          <Icon style="width: 28px; height: 28px;" icon="loot-crate"></Icon>

          <div>
            <h2 class="gmf-loot-crate-list-header-title gmf-subheader">{{ t('title') }}
            </h2>
            <div class="gmf-loot-crate-list-header-subtitle gmf-text-small" style="margin-right: var(--gmf-p-5); white-space: break-spaces;">{{
              t('description')
            }}
            </div>
          </div>
        </div>
      </div>

      <div class="gmf-loot-crate-list-padding" v-if="lootCrates.length">
        <div class="gmf-card gmf-loot-crate" v-for="crate, i in lootCrates" :key="i">
          <div class="gmf-loot-crate-img">
            <img class="gmf-loot-crate-img" :src="!openedCrates[crate.ids[0]] ? crate.imageUrl : crate.openImageUrl"
              alt="" width="128" height="96">
          </div>

          <div class="gmf-loot-crate-name-rewards">
            <div>
              <h3 class="gmf-loot-crate-title">{{ crate.label }}
              </h3>
              <div class="gmf-text-small gmf-loot-crate-list-crate-overflow-content" v-if="t(`types.${crate.typeName}.description`)">
                {{ t(`types.${crate.typeName}.description`) }}
              </div>
            </div>
          </div>

          <div class="gmf-loot-crate-buttons">
            <button style="flex-grow: 1;" class="gmf-btn gmf-btn-sm gmf-btn-primary"
              :disabled="openedCrates[crate.ids[0]]" @click="open(crate, {})">{{
                crate.ids.length === 1 ? t('open_btn') : t('open_all_btn')
              }} ×{{ crate.ids.length }}
            </button>
          </div>
        </div>
      </div>

      <div style="padding: var(--gmf-p-4)" v-else>
        <p>{{ t('no_loot_crates') }}</p>
      </div>
    </div>
  </div>
</template>

<style>
.gmf-modal-body.gmf-loot-crate-list {
  background-color: var(--gmf-col-lightgray) !important;
  padding: 0 !important;
}

.gmf-loot-crate-list-container {
  max-width: 100vw;
}

.gmf-loot-crate-list-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: var(--gmf-col-darkgray);
  border-top-right-radius: var(--gmf-modal-rounding);
  border-top-left-radius: var(--gmf-modal-rounding);
}

.gmf-loot-crate-list-padding {
  padding: var(--gmf-p-4);
}

.gmf-loot-crate-list-header-top {
  display: flex;
  flex-direction: row;
  gap: var(--gmf-p-4);
  align-items: center;
}

.gmf-loot-crate-list-header-title {
  color: var(--gmf-col-white) !important;
  margin-bottom: 0;
}

.gmf-loot-crate-list-header-subtitle {
  color: var(--gmf-col-white) !important;
}

.gmf-loot-crate-img {
  width: 64px;
  height: 64px;
}

.gmf-loot-crate {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--gmf-p-3);
  width: 100%;
}

.gmf-loot-crate-name-rewards {
  display: flex;
  flex-grow: 1;
}

.gmf-loot-crate-img {
  position: relative;
}

.gmf-loot-crate-buttons {
  display: flex;
  flex-wrap: wrap;
  white-space: nowrap;
  gap: var(--gmf-p-1);
  flex-grow: 0;
}

.gmf-loot-crate-title {
  font-weight: bold !important;
  margin: 0;
}
</style>

<script>
import callApi from '@/utils/callApi';
import showLootCrateRewards from './showLootCrateRewards';
import eventbus from '@/utils/eventbus';

import state from '@/state';

import Icon from '@/components/Icon.vue';

const t = state.t.prefix('loot_crates')

export default {
  components: {
    Icon
  },
  
  inject: ['closeModal'],

  data: () => ({
    openedCrates: {},

    lootCrates: [],
    totalQuantity: 0,
  }),

  methods: {
    t,
    async open(crate) {
      const type = crate.ids.length === 1 ? 'one' : 'multiple';

      const openTime = 2.5;
      const earliestRevealAt = Date.now() + Math.round(openTime * 1000);

      this.openedCrates[crate.ids[0]] = true;

      const res = await callApi('POST', '/v1/client/types/my-loot-crates/' + crate.typeName + '/open');

      if (res.status === 401) {
        this.error = 'session_expired'
        return;
      } else if (res.status !== 200) {
        this.error = 'crate_not_found'
        return;
      }

      const resBody = await res.json();

      const now = Date.now();

      if (now >= earliestRevealAt) {
        const contents = resBody.contents || [];
        crate.ids = (type === 'one') ? crate.ids.filter(c => c !== crate.ids[0]) : []
        this.openedCrates[crate.ids[0]] = false;

        showLootCrateRewards(crate, { autoOpen: false, type, contents });

        if (crate.ids.length === 0) {
          this.lootCrates = this.lootCrates.filter(c => c.typeName !== crate.typeName);
        }

        if (this.lootCrates.length === 0) {
          this.closeModal();
        }

        eventbus.emit('openedLootCrate');
      } else {
        setTimeout(() => {
          const contents = resBody.contents || [];
          crate.ids = (type === 'one') ? crate.ids.filter(c => c !== crate.ids[0]) : []
          this.openedCrates[crate.ids[0]] = false;

          showLootCrateRewards(crate, { autoOpen: false, type, contents });

          if (crate.ids.length === 0) {
            this.lootCrates = this.lootCrates.filter(c => c.typeName !== crate.typeName);
          }

          if (this.lootCrates.length === 0) {
            this.closeModal();
          }

          eventbus.emit('openedLootCrate');
        }, earliestRevealAt - now);
      }
    },

    async load() {
      const request = await callApi('GET', '/v1/client/my-loot-crates');
      const { lootCrates, totalQuantity } = await request.json();

      this.lootCrates = lootCrates;
      this.totalQuantity = totalQuantity;
    },
  },

  async mounted() {
    await this.load();

    eventbus.on('openedLootCrate', this.load);
  },

  unmounted() {
    eventbus.off('openedLootCrate', this.load);
  }
}
</script>